import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss'],
})
export class PaymentSummaryComponent implements OnInit {

  @Input() public taxInfo: TaxInfo;

  constructor(private utils:UtilsService) { }

  ngOnInit() {}

}


export interface TaxInfo {
  coins?:number
  beforeTax?: number
  total?: number
  provTax?: number
  taxPercent?:any
  headerText?:string,
  paymentType?:any
  paymentInfo?:any
  purchase?:any
}